'use strict';exports.__esModule = true;
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _components = require('../../../../components');

var _formatCurrency = require('../../../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _beautifyNumber = require('../../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _constants = require('../../../../constants');
var _images_placeholder = require('../../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _parkingConverter = require('../../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);

var _OMLeadPropertyCell = require('./OMLeadPropertyCell.scss');var styles = _interopRequireWildcard(_OMLeadPropertyCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMLeadPropertyCell = function (_Component) {_inherits(OMLeadPropertyCell, _Component);function OMLeadPropertyCell() {var _temp, _this, _ret;_classCallCheck(this, OMLeadPropertyCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.openDetails = function () {var _this$props$property =
      _this.props.property,id = _this$props$property.id,addressObject = _this$props$property.address,propertyType = _this$props$property.property_type,_this$props$property$ = _this$props$property.additional_info,rooms = _this$props$property$.rooms,area = _this$props$property$.area,floor = _this$props$property$.floor.on_the,parkingSpots = _this$props$property$.parking,price = _this$props$property.price,optionType = _this$props$property.search_option;
      _this.props.openDetailsPopup({
        propertyId: id,
        address: addressObject,
        price: price,
        optionType: optionType,
        propertyType: propertyType,
        additionalInfo: {
          area: area,
          floor: floor,
          parkingSpots: (0, _parkingConverter2.default)(parkingSpots),
          rooms: rooms } });


    }, _this.

    renderAddress = function (address) {
      var house = !!address.house_number ? ' ' + address.house_number : '';
      return (
        _react2.default.createElement('span', null,
          address.street_name, house, ',',
          _react2.default.createElement('br', null),
          address.city_name));


    }, _this.

    renderVRIcon = function () {return _this.props.property.vr_link &&
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelVR, 'icon', 'icon-vr-view') },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }),
        _react2.default.createElement('span', { className: 'path3' }),
        _react2.default.createElement('span', { className: 'path4' }),
        _react2.default.createElement('span', { className: 'path5' }));}, _this.



    renderProject = function () {var _this$props$property2 =


      _this.props.property,id = _this$props$property2.id,addressObject = _this$props$property2.address,propertyType = _this$props$property2.property_type,_this$props$property3 = _this$props$property2.additional_info,rooms = _this$props$property3.rooms,square = _this$props$property3.area.base,floor = _this$props$property3.floor.on_the,price = _this$props$property2.price,currency = _this$props$property2.currency,createdAt = _this$props$property2.created_at,thumbnail = _this$props$property2.thumbnail,images = _this$props$property2.images;var _this$props =

      _this.props,translate = _this$props.translate,_this$props$locale = _this$props.locale,locale = _this$props$locale === undefined ? 'en' : _this$props$locale;

      // eslint-disable-next-line max-len
      var address = addressObject[locale] ? _this.renderAddress(addressObject[locale]) : _this.renderAddress(addressObject.en);
      var image = (0, _get2.default)(images, '0') || null;
      var imageURL = thumbnail || image && (0, _constants.formatImageLink)(image);

      var propType = translate('propertyTypes', propertyType);
      var sentDate = (0, _moment2.default)(createdAt).format('DD/MM/YYYY');
      var houseNumberIsHidden = addressObject && addressObject.hide_house_number;

      return (
        _react2.default.createElement('div', {
            key: id,
            className: styles.cellWrapper },

          _react2.default.createElement('div', { className: styles.cellRow },
            _react2.default.createElement('div', { className: styles.image },
              _react2.default.createElement('div', { className: styles.statusCell }, status),
              _react2.default.createElement('div', { className: styles.price }, (0, _formatCurrency2.default)(currency) + ' ' + (0, _beautifyNumber2.default)(price)),
              _react2.default.createElement('div', {
                className: styles.bgImg,
                style: { backgroundImage: 'url(' + (imageURL || _images_placeholder2.default) + ')' } }),

              _this.renderVRIcon()),

            _react2.default.createElement('div', { className: styles.infoBlock },
              _react2.default.createElement('div', { className: styles.addressBlock },
                _react2.default.createElement('div', { className: styles.title }, propType, '\xA0', translate('title', _this.props.property.search_option)),
                _react2.default.createElement('div', { className: styles.address },
                  _react2.default.createElement('div', { onClick: _this.openDetails },
                    address),

                  _react2.default.createElement('div', { className: styles.addressCell },
                    _react2.default.createElement('div', { className: styles.exclamationTooltip },
                      houseNumberIsHidden &&
                      _react2.default.createElement(_components.BottomTooltip, {
                        icon: _react2.default.createElement('span', { className: styles.exclamationIcon }, _react2.default.createElement('i', { className: 'icon icon-exclamation' })),
                        warnTooltip: true,
                        className: 'exclamationIconTooltip',
                        msg: _react2.default.createElement('span', null, translate('publishProperty', 'houseNumberIsHidden')) })))),




                _react2.default.createElement('div', { className: styles.basicInfo },
                  _react2.default.createElement('span', null, rooms, '\xA0', _react2.default.createElement('i', { className: 'icon icon-door' })),
                  _react2.default.createElement('span', null, floor, '\xA0', _react2.default.createElement('i', { className: 'icon icon-floor' }))))))));






    }, _this.

    renderRemovedProject = function () {return (
        _react2.default.createElement('div', {
            className: styles.cellWrapper },

          _react2.default.createElement('div', { className: styles.cellRow },
            _react2.default.createElement('div', { className: styles.image },
              _react2.default.createElement('div', {
                className: styles.bgImg,
                style: { backgroundImage: 'url(' + _images_placeholder2.default + ')' } })),


            _react2.default.createElement('div', { className: styles.infoBlock },
              _react2.default.createElement('div', { className: styles.addressBlock },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.title, styles.remoteProjectTitle) },
                  _this.props.translate('header', 'remoteProject')))))));}, _temp), _possibleConstructorReturn(_this, _ret);}OMLeadPropertyCell.prototype.







  render = function render() {
    return this.props.property.id ? this.renderProject() : this.renderRemovedProject();
  };return OMLeadPropertyCell;}(_react.Component);exports.default = OMLeadPropertyCell;


OMLeadPropertyCell.propTypes = {
  property: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  openDetailsPopup: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  entityType: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMLeadPropertyCell/OMLeadPropertyCell.js
// module id = 2778
// module chunks = 0